
const getBorderColor = (mode) => {
  const borderColor = mode === "dark"
    ? "rgba(224, 224, 229, 0.3)"
    : "rgba(224, 224, 229, 1)";
  return borderColor;
}

export default getBorderColor